import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, min } from 'rxjs/operators';
import { CoreService } from '../core/core.service';
import { TransactionService } from './transaction.service';
import { Main } from '../core/main.service';

@Component({
  selector: 'cp-sales',
  templateUrl: './sales.component.html',
})

export class SalesComponent {

  sale: any;
  option: any;
  file: any;
  isLoading: any;
  id: string;
  saleForm!: FormGroup;
  config: any;
  operation: string;

  filter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  sales: any[];
  awards: any[];
  ekubMembers: any[];
  selectedAward: number = 0;
  selectedAwd: any = {};
  selectedSeller: any = {};

  constructor(private route: ActivatedRoute,
    private formBuilder: FormBuilder, private mainService: Main, private coreService: CoreService, private api: TransactionService, private router: Router,
    @Inject(Restangular) public Restangular) {
    this.filter = '';
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.sale = {
      'title': '',
      'position': 0,
      'remark': ''
    };
    this.isLoading = false;
    if (this.route.queryParams['value']['id']) {
      this.id = this.route.queryParams['value']['id'];
      //this.getSale();
    }
    this.operation = 'add';
    this.option = {
      width: '200',
      tags: true
    };
  }

  get award() { return this.saleForm.get('award'); }
  get seller() { return this.saleForm.get('seller'); }
  get buyer() { return this.saleForm.get('buyer'); }
  get transaction_date() { return this.saleForm.get('transaction_date'); }
  get deadline() { return this.saleForm.get('deadline'); }
  get min_offer() { return this.saleForm.get('min_offer'); }
  get sold_price() { return this.saleForm.get('sold_price'); }
  get commission_percentage() { return this.saleForm.get('commission_percentage'); }
  get commission_amount() { return this.saleForm.get('commission_amount'); }
  get status() { return this.saleForm.get('status'); }
  get remark() { return this.saleForm.get('remark'); }

  ngOnInit() {
    this.createForm();
    this.getSales()
    this.getAllAwards();
  }


  getAllAwards() {
    var filter = '&status=drawed';
    this.api.getAllAwards(filter).subscribe((resp: any) => {
      debugger;
      this.awards = resp.data;
      for (let award of this.awards) {
        award.text = award?.ekub?.data?.ekub_id + ' - ' + award?.code + ' - ' + award?.amount + ' ETB';
        award.id = award.id;
      }
    }, (err) => {
      debugger;
      //this.coreService.addToast('Error', err.statusText);
    });
  }

  getSales() {
    this.api.getSales(this.currentPage, this.filter).subscribe((resp: any) => {
      debugger;
      this.sales = resp.data;
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err) => {
      debugger;
      //this.coreService.addToast('Error', err.statusText);
    });
  }

  private createForm() {
    debugger;
    this.saleForm = this.formBuilder.group({
      award: ['', [Validators.required,]],
      seller: ['', [Validators.required]],
      buyer: ['',],
      transaction_date: [''],
      deadline: ['', Validators.required],
      min_offer: [0, [Validators.required, Validators.min(this.selectedAward)]],
      sold_price: [''],
      commission_percentage: [5],
      commission_amount: [0],
      status: ['pending', [Validators.required]],
      remark: [''],
    });
  }


  getWinner(event: any) {
    debugger;
    const result = this.awards.filter(
      (award: any) => award.id.toLowerCase().indexOf(event.id.toLowerCase()) !== -1
    );
    if (result.length > 0) {
      this.selectedAwd = result[0];
      this.selectedAward = this.selectedAwd?.amount;
      this.saleForm.get('seller').setValue(result[0].winner.data.username);
      this.selectedSeller = result[0].winner.data;
      this.getEkubMembers(result[0].ekub.data.id);
    }
  }

  calculateCommission(event: any) {
    debugger;
    this.commission_amount.setValue((this.min_offer.value - this.selectedAwd.amount) * (this.commission_percentage.value / 100));
  }
  getEkubMembers(ekubId: any) {
    debugger;
    this.api.getEkubMembers(ekubId).subscribe((res: any) => {
      debugger;
      if (res.data) {
        this.ekubMembers = res.data;
        if (this.selectedAwd) {
          var index = this.ekubMembers.map(x => {
            return x.id;
          }).indexOf(this.selectedAwd.winner.data.id);
          this.ekubMembers.splice(index, 1);
        }
        for (let member of this.ekubMembers) {
          member.text = member.username;
          member.id = member.id;
        }
      }
    });
  }

  changeStatus(sales: any, status: any) {
    debugger;
    if (!sales?.buyer) {
      this.mainService.toast({ title: 'Error: Buyer not found', body: 'please update the sales first to change status!', type: 'danger' });
      return;
    }
    this.api.changeSaleStatus(sales.id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getSales();
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

    });
  }

  getSale() {
    this.api.getSale(this.id).subscribe((res: any) => {
      debugger;
      this.sale = res.data;
      this.saleForm.setValue(res.data);
    });
  }


  fileChange(event): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }

  addSale() {
    debugger;
    var parsedValue = Number.parseFloat(this.min_offer.value);
    if (parsedValue < this.selectedAward) {
      this.mainService.toast({ title: 'Error', body: 'Minimum Offer Value must be greater than or equal to award value!', type: 'danger' });
    } else {
      this.isLoading = !this.isLoading;
      var id = this.sale.id;
      this.sale = this.saleForm.value;
      this.sale.seller = this.selectedSeller.id;
      this.api.createSales(this.sale, id).subscribe((res: any) => {
        //this.api.createSales({ sale: this.sale }, id).subscribe((res: any) => {
        debugger;
        this.isLoading = !this.isLoading;
        this.saleForm.reset();
        this.getSales();
        this.mainService.toast({ title: 'Success', body: (this.id) ? 'Sale successfully updated! ' : 'Sale  successfully added!', type: 'dark' });
      }, (err) => {
        debugger;
        err = err;
        this.isLoading = !this.isLoading;
        this.mainService.toast({ title: 'Error', body: (err.data.detail) ? err.data.detail : (this.id) ? 'Could not update sale!' : 'Could not add sale!', type: 'danger' });

      });
    }

  }

  reset() {
    debugger;
    this.operation = 'add';
    this.saleForm.reset();
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getSales();
  }

  editSale(sale: any) {
    debugger;
    this.getWinner(sale.award.data);
    this.sale = sale;
    this.award.setValue(sale.award.data.id);
    if (sale.buyer) {
      this.buyer.setValue(sale.buyer.data.id);
    }
    this.min_offer.setValue(sale.min_offer);
    this.transaction_date.setValue((sale.transaction_date) ? sale.transaction_date.split(" ")[0] : "");
    this.deadline.setValue(sale.deadline.split(" ")[0]);
    this.commission_amount.setValue(sale.commission_amount);
    if (sale.sold_price) {
      this.sold_price.setValue(sale.sold_price);
    }
    this.commission_percentage.setValue(sale.commission_percentage);
    this.status.setValue(sale.status);
    this.remark.setValue(sale.remark);
    this.operation = 'update';
  }

}
